export default {"src":"/_next/static/media/wrong-position-1-sitter.25c2817c.svg","height":61,"width":80,"blurWidth":0,"blurHeight":0};